import { inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';

import { AppState } from './initial-state';

export const injectUserBean = () =>
  toSignal(
    inject<Store<AppState>>(Store).select((state) => state.user),
    { requireSync: true }
  );
